import { InboxEntryFilters, InboxEntrySort } from '@this+that/models';

import {
  CardStatusFilter,
  DoBoxSortField,
  DoBoxSortOrder,
  DueDateFilter,
  PriorityFilter,
} from '../../../../components/DoBoxFilters/types';

interface BuildDoBoxBackendFiltersInput {
  hasActiveFilters: boolean;
  selectedFilterLabelIds: string[];
  showNoLabelsFilter: boolean;
  selectedDueDateFilters: DueDateFilter[];
  selectedPriorityFilters: PriorityFilter[];
  selectedCardStatusFilter: CardStatusFilter;
  showNoMembersFilter: boolean;
  selectedFilterMemberIds: string[];
  unreadOnly: boolean;
}

export function buildDoBoxBackendFilters({
  hasActiveFilters,
  selectedFilterLabelIds,
  showNoLabelsFilter,
  selectedDueDateFilters,
  selectedPriorityFilters,
  selectedCardStatusFilter,
  showNoMembersFilter,
  selectedFilterMemberIds,
  unreadOnly,
}: BuildDoBoxBackendFiltersInput): InboxEntryFilters | undefined {
  if (!hasActiveFilters) {
    return undefined;
  }

  return {
    ...(selectedFilterLabelIds.length > 0 && {
      labelIds: selectedFilterLabelIds,
    }),
    ...(showNoLabelsFilter && { showNoLabels: true }),
    ...(selectedDueDateFilters.length > 0 && {
      dueDateFilters: selectedDueDateFilters,
    }),
    ...(selectedCardStatusFilter !== CardStatusFilter.UNRESOLVED && {
      cardStatusFilter: selectedCardStatusFilter,
    }),
    ...(showNoMembersFilter && { showNoMembers: true }),
    ...(selectedFilterMemberIds.length > 0 && {
      memberIds: selectedFilterMemberIds,
    }),
    ...(unreadOnly && { unreadOnly: true }),
    ...(selectedPriorityFilters.length > 0 && {
      priorityFilters: selectedPriorityFilters,
    }),
  };
}

interface BuildDoBoxBackendSortInput {
  sortField: DoBoxSortField;
  sortOrder: DoBoxSortOrder;
}

export function buildDoBoxBackendSort({
  sortField,
  sortOrder,
}: BuildDoBoxBackendSortInput): InboxEntrySort {
  return {
    field: sortField,
    order: sortOrder,
  };
}
